import GenericModel from '../generic-model';
import { SubProject } from './sub-project';

export class Pickup extends GenericModel {
  subProject?: SubProject;
  extraInfoPickup?: string;
  ready?: boolean;
  constructor() {
    super();
  }
}
